var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAdressBook2 = function SvgAdressBook2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 2h2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-2V2z",
    fill: "#335EEA",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 2h12a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm7 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-5 5.5c-.011.162.265.5.404.5h9.177c.418 0 .424-.378.418-.5-.163-3.067-2.348-4.5-5.008-4.5-2.623 0-4.775 1.517-4.99 4.5z",
    fill: "#335EEA"
  }))));
};

export { SvgAdressBook2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48cGF0aCBkPSJNMTggMmgyYTMgMyAwIDAxMyAzdjE0YTMgMyAwIDAxLTMgM2gtMlYyeiIgZmlsbD0iIzMzNUVFQSIgb3BhY2l0eT0iLjMiLz48cGF0aCBkPSJNNSAyaDEyYTMgMyAwIDAxMyAzdjE0YTMgMyAwIDAxLTMgM0g1YTEgMSAwIDAxLTEtMVYzYTEgMSAwIDAxMS0xem03IDlhMiAyIDAgMTAwLTQgMiAyIDAgMDAwIDR6bS01IDUuNWMtLjAxMS4xNjIuMjY1LjUuNDA0LjVoOS4xNzdjLjQxOCAwIC40MjQtLjM3OC40MTgtLjUtLjE2My0zLjA2Ny0yLjM0OC00LjUtNS4wMDgtNC41LTIuNjIzIDAtNC43NzUgMS41MTctNC45OSA0LjV6IiBmaWxsPSIjMzM1RUVBIi8+PC9nPjwvc3ZnPg==";